import {
  IconButton,
  Checkbox,
  HStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  Button,
  Text,
  Modal,
  ModalHeader,
  ModalCloseButton,
  Box,
  Flex,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Center,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  PopoverCloseButton
} from '@chakra-ui/react'
import { format, parseISO } from 'date-fns'
import { FC, useMemo } from 'react'
import Highlighter from 'react-highlight-words'
import { AiOutlineComment } from 'react-icons/ai'
import { FaTruckLoading, FaHistory } from 'react-icons/fa'

import useTable from '@hook/shared/use-table'

import LayoutLoader from '@component/Layout/Loader'

import { parseCurrency } from '@helper/parseCurrency'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'
import useFollowUpAlert from '@base/hooks/alerts/use-followup'

const TableGridItemAlertFollowUp: FC<{ [key: string]: any }> = ({ data }) => {
  const { actions, columns, query } = useTable()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    getHistoric,
    dataHistoric,
    loadingModalHistoric,
    loadingModalHistoricExport,
    exportModalHistoric
  } = useFollowUpAlert()
  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left'
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])

  return (
    <>
      <tr>
        {actions && actions.length > 0 && (
          <td>
            <HStack
              spacing={2}
              w="100%"
              alignItems="center"
              justifyContent="center"
            >
              {actions.map((action, index) => {
                if (action.type === 'icon') {
                  return (
                    <IconButton
                      key={`table-action-${index}`}
                      aria-label="Abrir modal"
                      icon={action.icon}
                      size="xs"
                      onClick={() => action.onSelect!(data)}
                      _hover={{
                        bg: 'yellow.200'
                      }}
                      _active={{
                        bg: 'yellow.100'
                      }}
                    />
                  )
                }

                if (action.type === 'checkbox') {
                  if (action.isMulti) {
                    return (
                      <Checkbox
                        key={`table-action-${index}`}
                        colorScheme="red"
                        isChecked={action.selecteds.includes(
                          data['general-id']
                        )}
                        borderColor="blackAlpha.400"
                        alignItems="center"
                        onChange={() => {
                          if (action.onChange) {
                            action.onChange(data)
                          }
                        }}
                      />
                    )
                  } else {
                    return (
                      <Checkbox
                        key={`table-action-${index}`}
                        colorScheme="yellow"
                        isChecked={action.isChecked}
                        borderColor="blackAlpha.400"
                        alignItems="center"
                        isDisabled={
                          action.selecteds !== 0
                            ? action.selecteds !== data['id-id']
                            : false
                        }
                        onChange={() => {
                          if (action.onChange) {
                            action.onChange(data)
                          }
                        }}
                      />
                    )
                  }
                }
              })}
            </HStack>
          </td>
        )}
        {rows.map(({ id, value, align }, key) => (
          <td key={`${id}-${key}`} align={align || 'left'}>
            <div>
              {(() => {
                if (id === 'general-acao' && value !== '') {
                  return (
                    <Popover placement="top-start">
                      <PopoverTrigger>
                        <Button>
                          <AiOutlineComment color="green" size={20} />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent bgColor="white">
                        <PopoverHeader fontWeight="semibold" bgColor="white">
                          Comentario:{' '}
                          {format(
                            parseISO(value.split(';')[1]),
                            'dd/MM/yyyy HH:MM:SS'
                          )}
                        </PopoverHeader>
                        <PopoverArrow />
                        <PopoverCloseButton />
                        <PopoverBody bgColor="white">
                          <Text style={{ lineBreak: 'auto' }} isTruncated>
                            Data de Solução da Ação:{' '}
                            {format(
                              parseISO(value.split(';')[2]),
                              'dd/MM/yyyy'
                            )}
                            <br />
                            {value.split(';')[0]}
                          </Text>
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  )
                } else if (id === 'general-acao' && value === '') {
                  return (
                    <Button>
                      <AiOutlineComment color="gray" size={20} />
                    </Button>
                  )
                } else if (id === 'general-a-fornecer' && value === '') {
                  return parseCurrency({
                    value: value,
                    country: 'pt-br'
                  })
                } else if (id === 'general-a-fornecer-rs') {
                  return parseCurrency({
                    value: value,
                    country: 'pt-br'
                  })
                } else if (id === 'general-total-pedido') {
                  return parseCurrency({
                    value: value,
                    country: 'pt-br'
                  })
                } else if (id === 'general-status-entrega') {
                  return (
                    <FaTruckLoading
                      size={20}
                      color={
                        value === 2
                          ? '#3CB371'
                          : value === 3
                          ? '#F0E68C'
                          : '#FA8072'
                      }
                    />
                  )
                } else if (id === 'general-data-estimada') {
                  return (
                    <div>
                      {query.length > 0 ? (
                        <Highlighter
                          searchWords={String(query).split(' ')}
                          textToHighlight={String(value)}
                        />
                      ) : (
                        format(parseISO(value), 'dd/MM/yyyy')
                      )}
                    </div>
                  )
                } else if (
                  id === 'general-histórico' &&
                  value === 'historico'
                ) {
                  return (
                    <>
                      <Button
                        onClick={() => {
                          getHistoric(data['general-id'])
                          onOpen()
                        }}
                      >
                        <FaHistory size={20} />
                      </Button>
                      <Modal
                        isCentered
                        isOpen={isOpen}
                        onClose={onClose}
                        scrollBehavior="inside"
                        motionPreset="slideInBottom"
                        colorScheme="white"
                        size="xl"
                      >
                        <ModalOverlay />
                        <ModalContent
                          background={'white'}
                          marginLeft={[4, 8, 16]}
                          marginRight={[4, 8, 16]}
                        >
                          <ModalHeader
                            paddingTop={2}
                            paddingBottom={2}
                            paddingLeft={4}
                            paddingRight={4}
                            textColor={'gray.200'}
                            background={'#1d5840'}
                            borderTopLeftRadius={5}
                            borderTopRightRadius={5}
                            borderBottom="3px solid #ECC94B"
                          >
                            <Flex alignItems="center">
                              <Text marginLeft={2}>Historico Comentarios</Text>
                              <Flex marginLeft={2} marginTop={-1}>
                                |
                              </Flex>
                              <Button
                                variant="outline"
                                size="sm"
                                fontSize="md"
                                paddingX={2}
                                marginLeft={2}
                                isLoading={loadingModalHistoricExport}
                                onClick={() => {
                                  exportModalHistoric(data['general-id'])
                                }}
                              >
                                Exportar
                              </Button>
                            </Flex>
                          </ModalHeader>
                          <ModalCloseButton
                            top={1}
                            right={1.5}
                            textColor={'gray.200'}
                            size="lg"
                          />
                          <ModalBody bg="white">
                            <Box
                              p={4}
                              pos="relative"
                              h={280}
                              maxW="100%"
                              overflow="auto"
                            >
                              {loadingModalHistoric ? (
                                <LayoutLoader
                                  type="modal"
                                  title="Recuperando informações..."
                                  message="Aguarde enquanto buscamos os registros no banco de dados"
                                />
                              ) : (
                                <Table size="lg">
                                  <Thead>
                                    <Tr>
                                      <Th>Data</Th>
                                      <Th>Data Solução</Th>
                                      <Th>Comentario</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {dataHistoric.length === 0 ? (
                                      <Tr>
                                        <Td colSpan={3} align="center">
                                          Dados não encontrados
                                        </Td>
                                      </Tr>
                                    ) : (
                                      dataHistoric.map(value => (
                                        <>
                                          <Tr>
                                            <Td>
                                              {' '}
                                              {format(
                                                parseISO(value.dataCriacao),
                                                'dd/MM/yyyy hh:mm:ss'
                                              )}{' '}
                                            </Td>
                                            <Td>
                                              {' '}
                                              {format(
                                                parseISO(value.dataSolucao),
                                                'dd/MM/yyyy hh:mm:ss'
                                              )}{' '}
                                            </Td>
                                            <Td>{value.comentario}</Td>
                                          </Tr>
                                        </>
                                      ))
                                    )}
                                  </Tbody>
                                </Table>
                              )}
                            </Box>
                            <Center>
                              <Box
                                p={2}
                                alignItems="center"
                                alignContent="center"
                              >
                                <Button
                                  colorScheme="red"
                                  mr={3}
                                  onClick={onClose}
                                >
                                  Fechar
                                </Button>
                              </Box>
                            </Center>
                          </ModalBody>
                        </ModalContent>
                      </Modal>
                    </>
                  )
                } else if (id === 'general-historico' && value !== '') {
                  return (
                    <Button onClick={() => getHistoric(data['general-id'])}>
                      <FaHistory size={20} /> dwdw
                    </Button>
                  )
                } else {
                  return (
                    <div>
                      {query.length > 0 ? (
                        <Highlighter
                          searchWords={String(query).split(' ')}
                          textToHighlight={String(value)}
                        />
                      ) : (
                        value
                      )}
                    </div>
                  )
                }
              })()}
            </div>
          </td>
        ))}
      </tr>
    </>
  )
}

export default TableGridItemAlertFollowUp
